import { motion } from "framer-motion";

// Masked line-by-line reveal for hero headlines
export const LineReveal = ({ lines, className = "", delay = 0 }) => {
  return (
    <span className={className}>
      {lines.map((line, i) => (
        <span key={i} className="block overflow-hidden">
          <motion.span
            className="block"
            initial={{ y: "110%" }}
            animate={{ y: 0 }}
            transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1], delay: delay + i * 0.12 }}
          >
            {line}
          </motion.span>
        </span>
      ))}
    </span>
  );
};

// Scroll-triggered reveal wrapper.
// IMPORTANT: content must be visible even if animations don't fire (older Safari,
// reduce-motion, ad-blockers). We start visible and only add a subtle upward drift.
export const Reveal = ({ children, className = "", delay = 0, y = 24 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 1, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-40px" }}
    transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1], delay }}
  >
    {children}
  </motion.div>
);
